import React, { useState } from "react";
import AppButton from "../../common/AppButton";
import config from "../../config/config";
import colors from "../../config/colors";
import AppInput from "../../common/AppInput";
import { cloneDeep } from "lodash";
import numberOnly from "../../common/numberOnly";
import api from "../../config/api";
import DayTimeSlots from "../../components/DayTimeSlots";
import LabelText from "../../common/LabelText";
import { FaUserTie } from "react-icons/fa";
import { RiPhoneFill } from "react-icons/ri";
import { IoLocationSharp } from "react-icons/io5";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

const size = config.iconSize;
const formInit = {
  employeeId: "",
  name: "",
  contact: "",
  type: "",
  availability: [],
};

export default function CreateEmployeeModel() {
  const [disabled, setDisabled] = useState(false);
  const queryClient = useQueryClient();

  const Body = ({ onDone }) => {
    const [form, setForm] = useState(cloneDeep(formInit));
    const handleSubmit = async (event) => {
      event.preventDefault();

      const error = ["type"].reverse().filter((item) => {
        if (!form[item] || form[item]?.length === 0) {
          document.querySelector("#" + item + " input").focus();
          return item;
        }
        return false;
      });

      if (error.length > 0) return false;

      form.availability = Object.values(form.availability).filter(
        (i) => i.available
      );

      const res = await api.post("employees", {
        ...form,
        type: form.type.name,
      });
      if (!res.ok) {
        setDisabled(false);
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["employees"]);

      setDisabled(false);
      toast.success("Employee has been successfully created.");

      onDone && onDone();
    };
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      setDisabled(false);
      setForm({ ...form, [name]: value });
    };
    // const handleCheck = (value) => {
    //   const found = form.availability.find((i) => i.title === value);

    //   if (!found) {
    //     setForm({
    //       ...form,
    //       availability: [...form.availability, { title: value }],
    //     });
    //   } else {
    //     setForm({
    //       ...form,
    //       availability: form.availability.filter((i) => i.title !== value),
    //     });
    //   }
    // };
    // const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    return (
      <form id="form" onSubmit={handleSubmit}>
        <div className="d-flex " style={{ gap: 40, padding: "0px 30px" }}>
          <AppInput
            onChange={handleChange}
            leftIcon={<FaUserTie size={size} color={colors.silver} />}
            label="Name"
            floatLabel
            name="name"
            value={form.name}
            required
          />
          <AppInput
            leftIcon={<RiPhoneFill size={size} color={colors.silver} />}
            label="Contact"
            floatLabel
            onChange={handleChange}
            name="contact"
            type="tel"
            value={numberOnly(form.contact)}
            required
          />
          <AppInput
            onChange={handleChange}
            leftIcon={<IoLocationSharp size={size} color={colors.silver} />}
            id="type"
            label="Type"
            floatLabel
            type="dropdown"
            name="type"
            options={[
              { name: "Casual" },
              { name: "Regular" },
              { name: "Subcontractor" },
            ]}
            filterBy="name"
            value={form.type}
          />
        </div>
        <br />
        <br />
        <div className="d-flex " style={{ gap: 40, padding: "0px 30px" }}>
          <div>
            <LabelText label="Availability" />
            <DayTimeSlots
              onChange={(dt) => {
                setForm({ ...form, availability: dt });
              }}
            />
          </div>
        </div>
        <br />
        <br />
        <br />
      </form>
    );
  };
  const Header = () => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <b>Create Employee</b>
      </span>
    );
  };
  const Footer = () => {
    return (
      <AppButton
        disabled={disabled}
        text="Create"
        form="form"
        type="submit"
        className="text-primary btn-light"
      />
    );
  };

  return { Header, Body, Footer };
}
